<template>
  <v-dialog
    v-model="getModalClonarProduto"
    persistent
    max-width="720px"
    transition="dialog-transition"
  >
    <v-card>
      <v-card-title>
        Clonar Produto
      </v-card-title>
      <v-card-text>
        <h3 align="center">Tem certeza que deseja clonar este produto?</h3>
      </v-card-text>
      <v-card-actions>
        <v-btn color="default" outlined @click="setModalClonarProduto(false)"
          >Não</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn color="success" outlined @click="clonarProduto(getProduto.id), setModalClonarProduto(false)"
          >Sim</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
    computed: {
        ...mapGetters([
            'getProduto',
            'getModalClonarProduto',
        ])
    },
    methods: {
        ...mapActions([
            'setModalClonarProduto',
            'clonarProduto',
        ])
    }
};
</script>
